import { render, staticRenderFns } from "./category-navigation.vue?vue&type=template&id=596e0c5e&scoped=true"
import script from "./category-navigation.vue?vue&type=script&lang=js"
export * from "./category-navigation.vue?vue&type=script&lang=js"
import style0 from "./category-navigation.vue?vue&type=style&index=0&id=596e0c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e0c5e",
  null
  
)

export default component.exports